import { ModalFooter, ModalFooterButton } from '@/components/Modal'
import { useTexts } from './useTexts'
import { useOnCancel, useOnManageStorage } from '../../ContextProvider'

export function Footer() {
  const texts = useTexts()
  const onManageStorage = useOnManageStorage()
  const onCancel = useOnCancel()

  return (
    <ModalFooter
      primaryAction={
        <ModalFooterButton onClick={onCancel} testid="modal-primary-button" variant="contained">
          {texts.footer.cancel}
        </ModalFooterButton>
      }
      secondaryAction={
        <ModalFooterButton testid="modal-secondary-button" onClick={onManageStorage} color="error">
          {texts.footer.discard}
        </ModalFooterButton>
      }
    />
  )
}
